export enum RiskListType {
  DECUBITUS_EXTERNAL = 'DECUBITUS_EXTERNAL',
  INTERNAL_DECUBITUS = 'INTERNAL_DECUBITUS',
  MORE_WOUNDS = 'MORE_WOUNDS',
  FIXATION_BY_RESOLUTION = 'FIXATION_BY_RESOLUTION',
  FIXATION_AT_YOUR_OWN_REQUEST = 'FIXATION_AT_YOUR_OWN_REQUEST',
  PEG_PEJ_PROBE = 'PEG_PEJ_PROBE',
  URINARY_CATHETER = 'URINARY_CATHETER',
  STOMA = 'STOMA',
  COMPLETE_IMMOBILITY = 'COMPLETE_IMMOBILITY',
  CONTRACTURES = 'CONTRACTURES',
}
